import styled from '@emotion/styled';
import { Button } from '@paypalcorp/pp-react-buttons-weasley-v6';

import {
  LIGHT_BLUE_RGBA,
  PP_LIGHT_GRAY_COLOR,
  PP_SECONDARY_COLOR,
  PP_SELECTED_COLOR,
  PP_TERTIARY_COLOR,
} from '@/styles';

export const StyledCloseButton = styled(Button)`
  width: 48px;
  height: 48px;
  padding: 0.75rem;
  border-radius: 50%;
  color: ${PP_LIGHT_GRAY_COLOR};
  cursor: pointer;

  &:hover {
    background-color: ${PP_TERTIARY_COLOR};
    color: ${PP_LIGHT_GRAY_COLOR};
  }

  &:focus::after {
    padding: 0.75rem;
    border-radius: 50%;
    border: 1px solid ${PP_SELECTED_COLOR};
    box-shadow:
      ${PP_SECONDARY_COLOR} 0 0 0 2px inset,
      ${LIGHT_BLUE_RGBA} 0 0 0 5px;
  }
`;
